import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { RegisteredStatisticsIllustration } from '../../../../assets/illustration';
import { RegisteredStatisticsTriangleShape } from '../../../../assets/shapes';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { useRegisteredStatisticsQuery } from '../../../../store/features/registered-statistics/registeredStatisticsSlice';
import { registeredStatisticsStyles } from './styles';
import { RegisteredStatisticItem } from './RegisteredStatisticItem';
import { abbreviateNumber } from '../../../../utils/text';

export const RegisteredStatistics: React.FC = () => {
  const { isError, data: statistics, isLoading } = useRegisteredStatisticsQuery();

  if (isError) return null;

  return (
    <Box sx={{ position: 'relative' }}>
      <AppIcon role="presentation" Icon={RegisteredStatisticsTriangleShape} sx={registeredStatisticsStyles.triangle} />
      <Box className="container-fluid" sx={{ bgcolor: 'primary.light', py: 1 }}>
        <Grid
          direction={{ xs: 'column-reverse', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2.5}
          container
        >
          <Grid item md={8} xl={7}>
            <Typography sx={{ mb: 3 }} variant="h3" component="h2">
              <Typography component="span" variant="h3" sx={{ bgcolor: 'warning.light' }}>
                {isLoading || !statistics ? (
                  <CircularProgress size="1.75rem" color="secondary" />
                ) : (
                  `${abbreviateNumber(statistics.students)}+`
                )}{' '}
                Students
              </Typography>{' '}
              are exploring programs what fits them best.
            </Typography>
          </Grid>
          <Grid item>
            <AppIcon
              role="presentation"
              Icon={RegisteredStatisticsIllustration}
              sx={registeredStatisticsStyles.illustration}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2.5}>
          <Grid xs={12} md={4} item>
            <RegisteredStatisticItem isLoading={isLoading} count={statistics?.institutions} module="Institutes" />
          </Grid>
          <Grid xs={12} md={4} item>
            <RegisteredStatisticItem isLoading={isLoading} count={statistics?.programs} module="Programs" />
          </Grid>
          <Grid xs={12} md={4} item>
            <RegisteredStatisticItem isLoading={isLoading} count={statistics?.scholarships} module="Scholarships" />
          </Grid>
        </Grid>
      </Box>
      <AppIcon
        role="presentation"
        Icon={RegisteredStatisticsTriangleShape}
        sx={[registeredStatisticsStyles.triangle, registeredStatisticsStyles.triangleBottom]}
      />
    </Box>
  );
};
